// Lazysizes
import 'lazysizes';

// Tiny Slider
import { tns } from "../../node_modules/tiny-slider/src/tiny-slider"

import StringExtensions from "./extensions/string";
StringExtensions();
import ConsoleExtensions from "./extensions/console";
ConsoleExtensions();
import DomExtensions from "./extensions/dom";
DomExtensions();

// Alpine bootup

import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect'
import persist from '@alpinejs/persist'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'
import AutoAnimate from '@marcreichel/alpine-auto-animate';

Alpine.plugin(AutoAnimate);
Alpine.plugin(intersect);
Alpine.plugin(persist);
Alpine.plugin(focus);
Alpine.plugin(collapse);
window.Alpine = Alpine;

document.addEventListener('alpine:init', () => {
    // Tiny slider init
    window.tns = tns;

    //Alpine.store('bodyLock', {
    //    on: false,

    //    toggle() {
    //        this.on = !this.on
    //    }
    //})
    
    Alpine.store('preferences', {
        "productPhotoMode": Alpine.$persist('pack').using(sessionStorage),
        "listView": Alpine.$persist(true).using(sessionStorage),
    })
})

Alpine.start();

// aspnet-client-validation bootup

import { ValidationService } from 'aspnet-client-validation';

let v = new ValidationService();
v.bootstrap();


window.getVerificationToken = () => ({
    'RequestVerificationToken': document.getElementsByName('__RequestVerificationToken')[0].value
});

alert = (content, options) => {
    window.dispatchEvent(new CustomEvent('notify', {
        detail: {
            type: options?.type || 'info',
            content,
            persist: options?.persist || false,
            timeout: options?.timeout || 3000
        }
    }));
};